import React from 'react';

type Props = {
  className?: string;
  color?: string;
};

const SuccessIcon: React.FC<Props> = ({ className, color = '#298842' }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" className={className}>
    <g>
      <mask
        id="mask0_1209_9542"
        style={{ maskType: 'alpha' }}
        width="36"
        height="36"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#D9D9D9" d="M0 0H36V36H0z"></path>
      </mask>
      <g mask="url(#mask0_1209_9542)">
        <path
          fill={color}
          d="M15.9 24.9l10.575-10.575-2.1-2.1L15.9 20.7l-4.275-4.275-2.1 2.1L15.9 24.9zM18 33c-2.075 0-4.025-.394-5.85-1.181-1.825-.788-3.412-1.857-4.763-3.206-1.35-1.35-2.418-2.938-3.206-4.763C3.394 22.025 3 20.075 3 18c0-2.075.394-4.025 1.181-5.85.788-1.825 1.856-3.412 3.207-4.763 1.35-1.35 2.937-2.418 4.762-3.206C13.975 3.394 15.925 3 18 3c2.075 0 4.025.394 5.85 1.181 1.825.788 3.412 1.856 4.762 3.207 1.35 1.35 2.42 2.937 3.207 4.762C32.606 13.975 33 15.925 33 18c0 2.075-.394 4.025-1.181 5.85-.788 1.825-1.857 3.412-3.206 4.762-1.35 1.35-2.938 2.42-4.763 3.207C22.025 32.606 20.075 33 18 33z"
        ></path>
      </g>
    </g>
  </svg>
);

export default SuccessIcon;
